import { PublisherWebhookEventTypes } from "./publisher"

export const API_ROUTES = {
    LOGIN: '/store/auth/login',
    STORE_IMPERSONATION_LOGIN: '/store/auth/login/impersonation',
    RECONNECT: '/store/auth/reconnect',
    OFFERS: '/store/offers',
    EXTERNAL_LOGIN: '/store/auth/login/external',
    PUBLISHER_WEBHOOK: (eventType: PublisherWebhookEventTypes) => `/store/events/v2/${eventType}`,
    LANGUAGE_SUPPORTED: (publisherId: string) => `/store/translations/${publisherId}/languages`,
    LANGUAGE_TRANSLATIONS: (publisherId: string) => `/store/translations/${publisherId}/languages/{{lng}}`,
    AUTH_BOOT: (storeDomain: string) => `/store/${storeDomain}/boot/auth`,
    BOOT: (storeDomain: string, language?: string) => `/store/${storeDomain}/boot${language ? `?language=${encodeURIComponent(language)}` : ''}`,
    OTP_DEEP_LINK: '/store/otp/deeplink',
    ON_SHOP_LAND: '/store/analytics/shop-land',
    ORDER: (orderId: string) => `/store/orders/${orderId}`,
    CREATE_CHECKOUT_SESSION: '/store/orders/checkout-session/v2',
    CREATE_ORDER: '/store/orders',
    GET_STORE_CAMPAIGN: (tokenId: string) => `/store/campaign/${tokenId}`,
    GET_CAMPAIGN_METADATA: (token: string) => `/store/campaign/metadata?token=${encodeURIComponent(token)}`,
    KEEP_ALIVE: '/store/auth/keepalive',
    LOGOUT: '/store/auth/logout',
    SEND_ORDER_IMPRESSION: '/store/event',
    PRODUCTS_ASSETS: (productIds: string) => `/store/products/external-ids/${productIds}`,
    TEMPLATE: '/store/template',
    TEMPLATE_BY_ID: (templateId: string) => `/store/template/${encodeURIComponent(templateId)}`,
    UTMS: (domain: string) => `/store/domain/${domain}/utms`,
    MARKETING_EMAIL_OPT_OUT: '/store/marketing-email/opt-out',
} as const;
